/** @jsx jsx */
import { Box, Text, jsx } from 'theme-ui'
import { bool, func, object } from 'prop-types'
import { gql } from '@apollo/client'
import { useEffect, useState } from 'react'
import { Close } from '../icons/index'
import { Flex, IconButton } from 'theme-ui'
import Modal from '../components/common/Modal'

// query our graphql api to get data to post to distribion api
const GET_DISTRIBION_DATA_TO_POST = gql`
  query getDistribion($distribionResourceUrl: Uri) {
    distribionSamlResponse(distribionResourceUrl: $distribionResourceUrl) {
      postUrl
      samlResponse
    }
  }
`
// if we are not seeking a specific resource within distribion, request this default page (use in homepage dashboard and footer links)
const defaultDistribionLink =
  'https://studiotoolkit.dmplocal.com/main/index.php?action=mainmenu'

const FormModal = ({
  data,
  setDistribionFormVisible,
  distribionFormVisible,
  setFormSubmitted,
  formSubmitted,
}) => {
  const [encodedResponse, setEncodedResponse] = useState('')
  const [postUrl, setPostUrl] = useState('')
  useEffect(() => {
    if (data?.distribionSamlResponse) {
      setDistribionFormVisible(true)
      const encodedRes = window.btoa(data?.distribionSamlResponse.samlResponse)
      setEncodedResponse(encodedRes)
      setPostUrl(data?.distribionSamlResponse.postUrl)
    }
  }, [data])

  useEffect(() => {
    if (formSubmitted) {
      setDistribionFormVisible(false)
    }
  }, [formSubmitted])
  useEffect(() => {
    if (!distribionFormVisible) {
      setFormSubmitted(false)
    }
  }, [distribionFormVisible])

  return (
    <Modal
      handleDismiss={() => setDistribionFormVisible(false)}
      isOpen={distribionFormVisible}
      label="distribion form"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Flex
          sx={{
            justifyContent: 'flex-end',
            flexGrow: 1,
          }}
        >
          <IconButton
            onClick={() => setDistribionFormVisible(false)}
            aria-label="close resource detail dialog"
          >
            <Close />
          </IconButton>
        </Flex>
        <Flex
          sx={{
            flexDirection: 'column',
          }}
        >
          <p>
            Studio Toolkit will open in a new window. Use of the Marketing
            Library inside is free. There is a fee to order printed materials.
          </p>
          <Box
            as="form"
            method="post"
            action={postUrl}
            target="_blank"
            onSubmit={() => setFormSubmitted(true)}
          >
            <Text as="label" sx={{ display: 'none' }} htmlFor="fname">
              SAML
            </Text>
            <Text
              as="input"
              type="text"
              id="SAMLResponse"
              name="SAMLResponse"
              value={encodedResponse}
              readOnly
              sx={{ display: 'none' }}
            ></Text>
            <Text
              as="input"
              sx={{
                backgroundColor: 'forest',
                color: 'white',
                height: 50,
                minWidth: 143,
                border: 'none',
              }}
              type="submit"
              value="Open"
            ></Text>
          </Box>
        </Flex>
      </Box>
    </Modal>
  )
}

FormModal.propTypes = {
  data: object,
  distribionFormVisible: bool,
  setDistribionFormVisible: func,
  formSubmitted: bool,
  setFormSubmitted: func,
}

export { GET_DISTRIBION_DATA_TO_POST, defaultDistribionLink, FormModal }
